import { withRouter } from "react-router-dom";
import * as _ from "lodash";
import MainContent from "../../boxes/MainContent";
import PageHeader from "../../boxes/PageHeader";
import PageBody from "../../boxes/PageBody";
import { useTranslation } from "react-i18next";
import LoadingScreen from "../../LoadingScreen";
import { formatAsMoney } from "../utils/format-as-money";
import { format } from "date-fns";
import { connect } from "react-redux";
import { transactionTypes } from "../constants/transactionTypeMap";
import { getCareBalanceSelectors } from "../redux/careBalanceActions";

const paragraphStyles = {
  fontWeight: 500,
  fontSize: "1.6rem",
  color: "#4f4f4f",
};

const boldParagraphStyles = {
  ...paragraphStyles,
  fontWeight: 700,
  textAlign: "right",
};

function TitleWithBackground({ title }) {
  return (
    <div
      style={{
        backgroundColor: "#F2F2F2",
        padding: "12px",
        color: "#000000",
        fontWeight: 500,
        fontSize: "1.6rem",
        lineHeight: "100%",
        marginBottom: "8px",
      }}
    >
      <p>{title}</p>
    </div>
  );
}

function CareHistoryDetailContainer(props) {
  const { user, singleTransaction } = props;

  const { t } = useTranslation("careBalance");

  if (_.isEmpty(user?.hmoId)) {
    return <LoadingScreen />;
  }

  const isCredit = singleTransaction?.amount?.startsWith("-") ? false : true;

  const transactionTitle =
    isCredit &&
    singleTransaction?.transactionType === transactionTypes.FUND_WALLET
      ? t("careHistoryDetailAmountToppedUp")
      : isCredit
      ? t("careHistoryDetailAmountRefunded")
      : t("careHistoryDetailAmountDebited");

  const showMetadata = singleTransaction?.metadata?.category === "TPA";

  return (
    <>
      <MainContent>
        <PageHeader title={t("careHistoryPageTitle")} />

        <PageBody>
          <div
            className="dashboard-card"
            style={{
              maxWidth: "650px",
              margin: "0 auto",
              borderRadius: "4px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h2
              style={{
                fontWeight: 900,
                color: "#212121",
                fontSize: "1.659rem",
                marginBottom: "10px",
              }}
            >
              {transactionTitle}
            </h2>

            <p
              style={{
                fontSize: "3.2rem",
                lineHeight: "27px",
                color: isCredit ? "#288D68" : "#CB193B",
                fontWeight: 700,
                marginBottom: "24px",
              }}
            >
              {isCredit ? "+" : ""}
              {formatAsMoney({
                value: +singleTransaction?.amount,
              })}
            </p>

            <div
              style={{
                backgroundColor: "#18374C",
                width: "100%",
                padding: "16px",
                color: "#FFFFFF",
                fontWeight: 600,
                fontSize: "1.8rem",
                marginBottom: "24px",
                textAlign: "center",
              }}
            >
              {t("careHistoryDetailSummary")}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                gap: "8px",
                marginBottom: "24px",
              }}
            >
              <p style={paragraphStyles}>{t("careHistoryDetailReference")}</p>
              <p style={boldParagraphStyles}>
                {singleTransaction?.transactionRef}
              </p>
              <p style={paragraphStyles}>Date & Time</p>
              <p style={boldParagraphStyles}>
                {format(
                  new Date(singleTransaction?.date),
                  "yyyy-MM-dd HH:mm:ss"
                )}
              </p>
            </div>

            {showMetadata && (
              <>
                <div>
                  <TitleWithBackground
                    title={t("careHistoryDetailProviderDetails")}
                  />

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr auto",
                      gap: "8px",
                      marginBottom: "24px",
                    }}
                  >
                    <p style={paragraphStyles}>
                      {t("careHistoryDetailProviderDetails")}
                    </p>
                    <p style={{ ...paragraphStyles, textAlign: "right" }}>
                      {singleTransaction?.metadata?.provider_name}
                    </p>

                    <p style={paragraphStyles}>
                      {t("careHistoryDetailProviderLocation")}
                    </p>
                    <p style={{ ...paragraphStyles, textAlign: "right" }}>
                      {singleTransaction?.metadata?.provider_location}
                    </p>
                  </div>
                </div>

                <div>
                  <TitleWithBackground title={t("careHistoryDetailServices")} />

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr",
                      gap: "8px",
                      marginBottom: "24px",
                      marginTop: "8px",
                    }}
                  >
                    {(singleTransaction?.metadata?.benefits || []).map(
                      (benefit) => (
                        <p style={paragraphStyles}>{benefit?.item}</p>
                      )
                    )}
                  </div>
                </div>

                <div>
                  <TitleWithBackground
                    title={t("careHistoryDetailTotalCharges")}
                  />

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr",
                      gap: "8px",
                      marginBottom: "24px",
                      marginTop: "8px",
                    }}
                  >
                    <p
                      style={{
                        ...boldParagraphStyles,
                        color: isCredit ? "#288D68" : "#CB193B",
                      }}
                    >
                      {formatAsMoney({
                        value: +singleTransaction?.amount,
                      })}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </PageBody>
      </MainContent>
    </>
  );
}

function mapStateToProps(state) {
  return getCareBalanceSelectors(state);
}

export default withRouter(connect(mapStateToProps)(CareHistoryDetailContainer));
